import gql from 'graphql-tag';

export const _FIND_INVOICE_PAYMENT_TRIGGER = gql`
	query findInvoicePaymentTrigger($recipient: uuid!) {
		risolto_recipient(
			limit: 100
			where: {
				reference: { _eq: $recipient }
				invoice_documents: {
					status: { _eq: PAID }
					reference: { _is_null: false }
					action_invoices: {
						action_by_reference: {
							reference: { _is_null: false }
							# message_code:{_neq:"invoice"}
						}
					}
				}
			}
		) {
			invoice_documents(where: { status: { _eq: PAID } }) {
				due_date
				invoice_number
				status
				action_invoices(
					# where:{
					# action_by_reference:{
					# message_code:{_neq:"invoice"}
					#   }
					# }
					order_by: { action_by_reference: { confirmed_at: desc_nulls_last } }
					limit: 1
				) {
					action_by_reference {
						reference
						channel
						message_code
						executed_at
						updated_at
						action_invoices {
							reference
							invoice
							invoice_by_reference {
								invoice_number
							}
						}
					}
				}
			}
			account_id
		}
	}
`;
